const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api";

function apiOrigin() {
  try {
    return new URL(API_BASE).origin;
  } catch {
    return "http://127.0.0.1:8000";
  }
}

/**
 * Laravel APP_URL often mismatches the dev API (e.g. http://localhost vs :8000).
 * For anything under /storage, always use the same origin as REACT_APP_API_BASE_URL.
 */
function normalizeAbsoluteStorageUrl(absoluteUrl, origin) {
  try {
    const parsed = new URL(absoluteUrl);
    if (parsed.pathname.startsWith("/storage")) {
      return `${origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    /* ignore */
  }
  return absoluteUrl;
}

/**
 * Build a browser-loadable image URL for a weblist image.
 *
 * @param {object} webL
 * @param {{ cacheBust?: boolean }} [options]
 * @returns {string|null}
 */
export function resolveImageSrc(webL, options = {}) {
  if (!webL) return null;

  const { img_url: rawUrl, image: path } = webL;
  const origin = apiOrigin();
  let src = null;

  // Prefer DB path + CRA env origin — ignores wrong Laravel APP_URL on absolute profile_picture_url.
  if (path) {
    const clean = String(path).replace(/^\/+/, "");
    src = `${origin}/storage/${clean}`;
  } else if (rawUrl) {
    const u = String(rawUrl).trim();
    if (/^https?:\/\//i.test(u)) {
      src = normalizeAbsoluteStorageUrl(u, origin);
    } else if (u.startsWith("/")) {
      src = `${origin}${u}`;
    }
  }

  if (src && options.cacheBust && webL.updated_at) {
    const sep = src.includes("?") ? "&" : "?";
    src = `${src}${sep}v=${encodeURIComponent(webL.updated_at)}`;
  }

  return src;
}
